import { motion } from "framer-motion";
import { TypeAnimation } from 'react-type-animation';
import heroCover from "../assets/hero/Cover.png";
import Button from "./Button";

const Hero = ({ onGetStarted }) => {
  return (
    <section className="relative min-h-screen flex items-center justify-center py-32 lg:py-36 overflow-hidden">
      <div className="container mx-auto px-4">
        <div className="text-center max-w-[800px] mx-auto mb-12">
          {/* Tag */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="inline-block px-6 py-2 mb-8 rounded-full bg-gradient-to-r from-[#1E2A4A] to-[#2A3B66] backdrop-blur-xl"
          >
            <span className="text-gray-300 font-medium">
              🚀 The Future of AI Technology
            </span>
          </motion.div>

          {/* Heading */}
          <motion.h1
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.1 }}
            className="text-5xl md:text-6xl lg:text-7xl font-bold mb-8 leading-tight"
          >
            <span className="gradient-text">Revolutionize Your</span>
            <br />
            <span className="text-customDark dark:text-white">
              <TypeAnimation
                sequence={[
                  'Digital Experience',
                  2000,
                  'AI Journey',
                  2000,
                  'Creative Process',
                  2000,
                  'Business Growth',
                  2000,
                  'Innovation Path',
                  2000,
                ]}
                wrapper="span"
                speed={50}
                repeat={Infinity}
                className="text-customDark dark:text-white"
              />
            </span>
          </motion.h1>

          {/* Description */}
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.2 }}
            className="text-xl text-gray-400 mb-12 leading-relaxed"
          >
            Transform your ideas into reality with our cutting-edge AI platform.
            Experience the next generation of artificial intelligence.
          </motion.p>

          {/* CTA Buttons */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.3 }}
            className="flex flex-wrap gap-6 justify-center mb-16"
          >
            <Button 
              href="#"
              className="button button-primary px-8 py-4 cursor-pointer"
              onClick={(e) => {
                e.preventDefault();
                onGetStarted();
              }}
            >
              Get Started Free
            </Button>
            <Button className="button border border-[#1E2A4A] hover:border-gray-700 px-8 py-4">
              Learn More
            </Button>
          </motion.div>

          {/* Features */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.4 }}
            className="flex flex-wrap gap-8 justify-center text-gray-400"
          >
            <span className="flex items-center gap-2">
              <svg className="w-5 h-5 text-green-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
              </svg>
              Free 14-day trial
            </span>
            <span className="flex items-center gap-2">
              <svg className="w-5 h-5 text-green-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
              </svg>
              No credit card required
            </span>
          </motion.div>
        </div>

        {/* Hero image */}
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.4 }}
          className="relative max-w-[1200px] mx-auto"
        >
          <div className="relative z-1">
            {/* Browser frame */}
            <div className="gradient-border p-1 rounded-2xl">
              <div className="relative bg-[#ffffff]/40 dark:bg-[#151C31] rounded-2xl overflow-hidden">
                {/* Browser toolbar */}
                <div className="h-12 bg-[#1E2A4A] rounded-t-2xl flex items-center gap-2 px-4">
                  <div className="flex gap-2">
                    <div className="w-3 h-3 rounded-full bg-red-500" />
                    <div className="w-3 h-3 rounded-full bg-yellow-500" />
                    <div className="w-3 h-3 rounded-full bg-green-500" />
                  </div>
                  
                  {/* Address bar */}
                  <div className="ml-4 flex-1 flex items-center">
                    <div className="bg-[#0F1629] rounded-lg py-1.5 px-4 text-xs text-gray-400 flex-1 max-w-[440px]">
                      intellishift.ai/dashboard
                    </div>
                  </div>
                </div>

                {/* Browser content */}
                <div className="relative aspect-[1200/800]">
                  <img 
                    src={heroCover} 
                    className="absolute inset-0 w-full h-full object-cover"
                    width={1200}
                    height={800}
                    alt="AI-powered digital experience"
                  />
                  
                  {/* Gradient overlay */}
                  <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent" />
                </div>
              </div>
            </div>
          </div>

          {/* Background glow effect */}
          <div className="absolute -inset-2 bg-[#6366f1]/20 blur-3xl rounded-full -z-10" />
        </motion.div>
      </div>
    </section>
  );
};

export default Hero;
